import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as VinWonderPriceActions from './../../../../../actions/VinWonderPriceAction';
import VinWonderPriceDetail from './VinWonderPriceDetail';

const mapStateToProps = state => {
    return {
        vinWonderPriceState: state.vinWonderPriceReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVinWonderPriceDetail: (id) => dispatch(VinWonderPriceActions.getVinWonderPriceDetail(id)),
        setVinWonderPriceDetail: (price) => dispatch(VinWonderPriceActions.setVinWonderPriceDetail(price)),
        updateVinWonderPriceDetail: (price) => dispatch(VinWonderPriceActions.updateVinWonderPriceDetail(price)),
        createVinWonderPriceDetail: (price) => dispatch(VinWonderPriceActions.createVinWonderPriceDetail(price)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderPriceDetail));
